function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import PropTypes from 'prop-types';
export { default as PropTypes } from 'prop-types';
import { render, cloneElement, createRef, h, Component, options } from 'preact';
export { createRef } from 'preact';
import { createContext } from 'preact-context';
export { createContext } from 'preact-context';
var version = '15.1.0'; // trick libraries to think we are react

var ELEMENTS = 'a abbr address area article aside audio b base bdi bdo big blockquote body br button canvas caption cite code col colgroup data datalist dd del details dfn dialog div dl dt em embed fieldset figcaption figure footer form h1 h2 h3 h4 h5 h6 head header hgroup hr html i iframe img input ins kbd keygen label legend li link main map mark menu menuitem meta meter nav noscript object ol optgroup option output p param picture pre progress q rp rt ruby s samp script section select small source span strong style sub summary sup table tbody td textarea tfoot th thead time title tr track u ul var video wbr circle clipPath defs ellipse g image line linearGradient mask path pattern polygon polyline radialGradient rect stop svg text tspan'.split(' ');
var REACT_ELEMENT_TYPE = typeof Symbol !== 'undefined' && Symbol["for"] && Symbol["for"]('react.element') || 0xeac7;
var COMPONENT_WRAPPER_KEY = typeof Symbol !== 'undefined' && Symbol["for"] ? Symbol["for"]('__preactCompatWrapper') : '__preactCompatWrapper'; // don't autobind these methods since they already have guaranteed context.

var AUTOBIND_BLACKLIST = {
  constructor: 1,
  render: 1,
  shouldComponentUpdate: 1,
  componentWillReceiveProps: 1,
  componentWillUpdate: 1,
  componentDidUpdate: 1,
  componentWillMount: 1,
  componentDidMount: 1,
  componentWillUnmount: 1,
  componentDidUnmount: 1
};
var CAMEL_PROPS = /^(?:accent|alignment|arabic|baseline|cap|clip|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vector|vert|word|writing|x)[A-Z]/;
var BYPASS_HOOK = {};
/*global process*/

var DEV = false;

try {
  _assign__("DEV", process.env.NODE_ENV !== 'production');
} catch (e) {} // a component that renders nothing. Used to replace components for unmountComponentAtNode.


function EmptyComponent() {
  return null;
} // make react think we're react.


var VNode = _get__("h")('a', null).constructor;

_get__("VNode").prototype.$$typeof = _get__("REACT_ELEMENT_TYPE");
_get__("VNode").prototype.preactCompatUpgraded = false;
_get__("VNode").prototype.preactCompatNormalized = false;
Object.defineProperty(_get__("VNode").prototype, 'type', {
  get: function get() {
    return this.nodeName;
  },
  set: function set(v) {
    this.nodeName = v;
  },
  configurable: true
});
Object.defineProperty(_get__("VNode").prototype, 'props', {
  get: function get() {
    return this.attributes;
  },
  set: function set(v) {
    this.attributes = v;
  },
  configurable: true
});

var oldEventHook = _get__("options").event;

_get__("options").event = function (e) {
  if (_get__("oldEventHook")) {
    e = _get__("oldEventHook")(e);
  }

  e.persist = Object;
  e.nativeEvent = e;
  return e;
};

var oldVnodeHook = _get__("options").vnode;

_get__("options").vnode = function (vnode) {
  if (!vnode.preactCompatUpgraded) {
    vnode.preactCompatUpgraded = true;
    var tag = vnode.nodeName,
        attrs = vnode.attributes = vnode.attributes == null ? {} : _get__("extend")({}, vnode.attributes);

    if (typeof tag === 'function') {
      if (tag[COMPONENT_WRAPPER_KEY] === true || tag.prototype && 'isReactComponent' in tag.prototype) {
        if (vnode.children && String(vnode.children) === '') {
          vnode.children = undefined;
        }

        if (vnode.children) {
          attrs.children = vnode.children;
        }

        if (!vnode.preactCompatNormalized) {
          _get__("normalizeVNode")(vnode);
        }

        _get__("handleComponentVNode")(vnode);
      }
    } else {
      if (vnode.children && String(vnode.children) === '') {
        vnode.children = undefined;
      }

      if (vnode.children) {
        attrs.children = vnode.children;
      }

      if (attrs.defaultValue) {
        if (!attrs.value && attrs.value !== 0) {
          attrs.value = attrs.defaultValue;
        }

        delete attrs.defaultValue;
      }

      _get__("handleElementVNode")(vnode, attrs);
    }
  }

  if (_get__("oldVnodeHook")) {
    _get__("oldVnodeHook")(vnode);
  }
};

function handleComponentVNode(vnode) {
  var tag = vnode.nodeName,
      a = vnode.attributes;
  vnode.attributes = {};

  if (tag.defaultProps) {
    _get__("extend")(vnode.attributes, tag.defaultProps);
  }

  if (a) {
    _get__("extend")(vnode.attributes, a);
  }
}

function handleElementVNode(vnode, a) {
  var shouldSanitize, attrs, i;

  if (a) {
    for (i in a) {
      if (shouldSanitize = _get__("CAMEL_PROPS").test(i)) {
        break;
      }
    }

    if (shouldSanitize) {
      attrs = vnode.attributes = {};

      for (i in a) {
        if (a.hasOwnProperty(i)) {
          attrs[_get__("CAMEL_PROPS").test(i) ? i.replace(/([A-Z0-9])/, '-$1').toLowerCase() : i] = a[i];
        }
      }
    }
  }
} // proxy render() since React returns a Component reference.


function render$1(vnode, parent, callback) {
  var prev = parent && parent._preactCompatRendered && parent._preactCompatRendered.base; // ignore impossible previous renders

  if (prev && prev.parentNode !== parent) {
    prev = null;
  } // default to first Element child


  if (!prev && parent) {
    prev = parent.firstElementChild;
  } // remove unaffected siblings


  for (var i = parent.childNodes.length; i--;) {
    if (parent.childNodes[i] !== prev) {
      parent.removeChild(parent.childNodes[i]);
    }
  }

  var out = _get__("render")(vnode, parent, prev);

  if (parent) {
    parent._preactCompatRendered = out && (out._component || {
      base: out
    });
  }

  if (typeof callback === 'function') {
    callback();
  }

  return out && out._component || out;
}

var ContextProvider = function ContextProvider() {};

_get__("ContextProvider").prototype.getChildContext = function () {
  return this.props.context;
};

_get__("ContextProvider").prototype.render = function (props) {
  return props.children[0];
};

function renderSubtreeIntoContainer(parentComponent, vnode, container, callback) {
  var wrap = _get__("h")(_get__("ContextProvider"), {
    context: parentComponent.context
  }, vnode);

  var renderContainer = _get__("render$1")(wrap, container);

  var component = renderContainer._component || renderContainer.base;

  if (callback) {
    callback.call(component, renderContainer);
  }

  return component;
}

function Portal(props) {
  _get__("renderSubtreeIntoContainer")(this, props.vnode, props.container);
}

function createPortal(vnode, container) {
  return _get__("h")(_get__("Portal"), {
    vnode: vnode,
    container: container
  });
}

function unmountComponentAtNode(container) {
  var existing = container._preactCompatRendered && container._preactCompatRendered.base;

  if (existing && existing.parentNode === container) {
    _get__("render")(_get__("h")(_get__("EmptyComponent")), container, existing);

    return true;
  }

  return false;
}

var ARR = []; // This API is completely unnecessary for Preact, so it's basically passthrough.

var Children = {
  map: function map(children, fn, ctx) {
    if (children == null) {
      return null;
    }

    children = _get__("Children").toArray(children);

    if (ctx && ctx !== children) {
      fn = fn.bind(ctx);
    }

    return children.map(fn);
  },
  forEach: function forEach(children, fn, ctx) {
    if (children == null) {
      return null;
    }

    children = _get__("Children").toArray(children);

    if (ctx && ctx !== children) {
      fn = fn.bind(ctx);
    }

    children.forEach(fn);
  },
  count: function count(children) {
    return children && children.length || 0;
  },
  only: function only(children) {
    children = _get__("Children").toArray(children);

    if (children.length !== 1) {
      throw new Error('Children.only() expects only one child.');
    }

    return children[0];
  },
  toArray: function toArray(children) {
    if (children == null) {
      return [];
    }

    return _get__("ARR").concat(children);
  }
};
/** Track current render() component for ref assignment */

var currentComponent;

function createFactory(type) {
  return _get__("createElement").bind(null, type);
}

var DOM = {};

for (var i = _get__("ELEMENTS").length; _update_operation__("--", "i", false);) {
  _get__("DOM")[_get__("ELEMENTS")[i]] = _get__("createFactory")(_get__("ELEMENTS")[i]);
}

function upgradeToVNodes(arr, offset) {
  for (var i = offset || 0; i < arr.length; i++) {
    var obj = arr[i];

    if (Array.isArray(obj)) {
      _get__("upgradeToVNodes")(obj);
    } else if (obj && _typeof(obj) === 'object' && !_get__("isValidElement")(obj) && (obj.props && obj.type || obj.attributes && obj.nodeName || obj.children)) {
      arr[i] = _get__("createElement")(obj.type || obj.nodeName, obj.props || obj.attributes, obj.children);
    }
  }
}

function isStatelessComponent(c) {
  return typeof c === 'function' && !(c.prototype && c.prototype.render);
} // wraps stateless functional components in a PropTypes validator


function wrapStatelessComponent(WrappedComponent) {
  return _get__("createClass")({
    displayName: WrappedComponent.displayName || WrappedComponent.name,
    render: function render() {
      return WrappedComponent(this.props, this.context);
    }
  });
}

function statelessComponentHook(Ctor) {
  var Wrapped = Ctor[COMPONENT_WRAPPER_KEY];

  if (Wrapped) {
    return Wrapped === true ? Ctor : Wrapped;
  }

  Wrapped = _get__("wrapStatelessComponent")(Ctor);
  Object.defineProperty(Wrapped, _get__("COMPONENT_WRAPPER_KEY"), {
    configurable: true,
    value: true
  });
  Wrapped.displayName = Ctor.displayName;
  Wrapped.propTypes = Ctor.propTypes;
  Wrapped.defaultProps = Ctor.defaultProps;
  Object.defineProperty(Ctor, _get__("COMPONENT_WRAPPER_KEY"), {
    configurable: true,
    value: Wrapped
  });
  return Wrapped;
}

function createElement() {
  var args = [],
      len = arguments.length;

  while (len--) {
    args[len] = arguments[len];
  }

  _get__("upgradeToVNodes")(args, 2);

  return _get__("normalizeVNode")(_get__("h").apply(void 0, args));
}

function normalizeVNode(vnode) {
  vnode.preactCompatNormalized = true;

  _get__("applyClassName")(vnode);

  if (_get__("isStatelessComponent")(vnode.nodeName)) {
    vnode.nodeName = _get__("statelessComponentHook")(vnode.nodeName);
  }

  var ref = vnode.attributes.ref,
      type = ref && _typeof(ref);

  if (_get__("currentComponent") && (type === 'string' || type === 'number')) {
    vnode.attributes.ref = _get__("createStringRefProxy")(ref, _get__("currentComponent"));
  }

  _get__("applyEventNormalization")(vnode);

  return vnode;
}

function cloneElement$1(element, props) {
  var children = [],
      len = arguments.length - 2;

  while (len-- > 0) {
    children[len] = arguments[len + 2];
  }

  if (!_get__("isValidElement")(element)) {
    return element;
  }

  var elementProps = element.attributes || element.props;

  var node = _get__("h")(element.nodeName || element.type, _get__("extend")({}, elementProps), element.children || elementProps && elementProps.children); // Only provide the 3rd argument if needed.
  // Arguments 3+ overwrite element.children in preactCloneElement


  var cloneArgs = [node, props];

  if (children && children.length) {
    cloneArgs.push(children);
  } else if (props && props.children) {
    cloneArgs.push(props.children);
  }

  return _get__("normalizeVNode")(_get__("cloneElement").apply(void 0, cloneArgs));
}

function isValidElement(element) {
  return element && (element instanceof _get__("VNode") || element.$$typeof === _get__("REACT_ELEMENT_TYPE"));
}

function createStringRefProxy(name, component) {
  return component._refProxies[name] || (component._refProxies[name] = function (resolved) {
    if (component && component.refs) {
      component.refs[name] = resolved;

      if (resolved === null) {
        delete component._refProxies[name];
        component = null;
      }
    }
  });
}

function applyEventNormalization(ref) {
  var nodeName = ref.nodeName;
  var attributes = ref.attributes;

  if (!attributes || typeof nodeName !== 'string') {
    return;
  }

  var props = {};

  for (var i in attributes) {
    props[i.toLowerCase()] = i;
  }

  if (props.ondoubleclick) {
    attributes.ondblclick = attributes[props.ondoubleclick];
    delete attributes[props.ondoubleclick];
  } // for *textual inputs* (incl textarea), normalize `onChange` -> `onInput`:


  if (props.onchange && (nodeName === 'textarea' || nodeName.toLowerCase() === 'input' && !/^fil|che|rad/i.test(attributes.type))) {
    var normalized = props.oninput || 'oninput';

    if (!attributes[normalized]) {
      attributes[normalized] = _get__("multihook")([attributes[normalized], attributes[props.onchange]]);
      delete attributes[props.onchange];
    }
  }
}

function applyClassName(vnode) {
  var a = vnode.attributes || (vnode.attributes = {});
  _get__("classNameDescriptor").enumerable = 'className' in a;

  if (a.className) {
    a["class"] = a.className;
  }

  Object.defineProperty(a, 'className', _get__("classNameDescriptor"));
}

var classNameDescriptor = {
  configurable: true,
  get: function get() {
    return this["class"];
  },
  set: function set(v) {
    this["class"] = v;
  }
};

function extend(base, props) {
  var arguments$1 = arguments;

  for (var i = 1, obj = void 0; i < arguments.length; i++) {
    if (obj = arguments$1[i]) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          base[key] = obj[key];
        }
      }
    }
  }

  return base;
}

function shallowDiffers(a, b) {
  for (var i in a) {
    if (!(i in b)) {
      return true;
    }
  }

  for (var i$1 in b) {
    if (a[i$1] !== b[i$1]) {
      return true;
    }
  }

  return false;
}

function findDOMNode(component) {
  return component && (component.base || component.nodeType === 1 && component) || null;
}

function F() {}

function createClass(obj) {
  function cl(props, context) {
    _get__("bindAll")(this);

    _get__("Component$1").call(this, props, context, _get__("BYPASS_HOOK"));

    _get__("newComponentHook").call(this, props, context);
  }

  obj = _get__("extend")({
    constructor: cl
  }, obj); // We need to apply mixins here so that getDefaultProps is correctly mixed

  if (obj.mixins) {
    _get__("applyMixins")(obj, _get__("collateMixins")(obj.mixins));
  }

  if (obj.statics) {
    _get__("extend")(cl, obj.statics);
  }

  if (obj.propTypes) {
    cl.propTypes = obj.propTypes;
  }

  if (obj.defaultProps) {
    cl.defaultProps = obj.defaultProps;
  }

  if (obj.getDefaultProps) {
    cl.defaultProps = obj.getDefaultProps.call(cl);
  }

  _get__("F").prototype = _get__("Component$1").prototype;
  cl.prototype = _get__("extend")(new (_get__("F"))(), obj);
  cl.displayName = obj.displayName || 'Component';
  return cl;
} // Flatten an Array of mixins to a map of method name to mixin implementations


function collateMixins(mixins) {
  var keyed = {};

  for (var i = 0; i < mixins.length; i++) {
    var mixin = mixins[i];

    for (var key in mixin) {
      if (mixin.hasOwnProperty(key) && typeof mixin[key] === 'function') {
        (keyed[key] || (keyed[key] = [])).push(mixin[key]);
      }
    }
  }

  return keyed;
} // apply a mapping of Arrays of mixin methods to a component prototype


function applyMixins(proto, mixins) {
  for (var key in mixins) {
    if (mixins.hasOwnProperty(key)) {
      proto[key] = _get__("multihook")(mixins[key].concat(proto[key] || _get__("ARR")), key === 'getDefaultProps' || key === 'getInitialState' || key === 'getChildContext');
    }
  }
}

function bindAll(ctx) {
  for (var i in ctx) {
    var v = ctx[i];

    if (typeof v === 'function' && !v.__bound && !_get__("AUTOBIND_BLACKLIST").hasOwnProperty(i)) {
      (ctx[i] = v.bind(ctx)).__bound = true;
    }
  }
}

function callMethod(ctx, m, args) {
  if (typeof m === 'string') {
    m = ctx.constructor.prototype[m];
  }

  if (typeof m === 'function') {
    return m.apply(ctx, args);
  }
}

function multihook(hooks, skipDuplicates) {
  return function () {
    var arguments$1 = arguments;
    var this$1 = this;
    var ret;

    for (var i = 0; i < hooks.length; i++) {
      var r = _get__("callMethod")(this$1, hooks[i], arguments$1);

      if (skipDuplicates && r != null) {
        if (!ret) {
          ret = {};
        }

        for (var key in r) {
          if (r.hasOwnProperty(key)) {
            ret[key] = r[key];
          }
        }
      } else if (typeof r !== 'undefined') {
        ret = r;
      }
    }

    return ret;
  };
}

function newComponentHook(props, context) {
  _get__("propsHook").call(this, props, context);

  this.componentWillReceiveProps = _get__("multihook")([_get__("propsHook"), this.componentWillReceiveProps || 'componentWillReceiveProps']);
  this.render = _get__("multihook")([_get__("propsHook"), _get__("beforeRender"), this.render || 'render', _get__("afterRender")]);
}

function propsHook(props, context) {
  if (!props) {
    return;
  } // React annoyingly special-cases single children, and some react components are ridiculously strict about this.


  var c = props.children;

  if (c && Array.isArray(c) && c.length === 1 && (typeof c[0] === 'string' || typeof c[0] === 'function' || c[0] instanceof _get__("VNode"))) {
    props.children = c[0]; // but its totally still going to be an Array.

    if (props.children && _typeof(props.children) === 'object') {
      props.children.length = 1;
      props.children[0] = props.children;
    }
  } // add proptype checking


  if (_get__("DEV")) {
    var ctor = typeof this === 'function' ? this : this.constructor,
        propTypes = this.propTypes || ctor.propTypes;
    var displayName = this.displayName || ctor.name;

    if (propTypes) {
      _get__("PropTypes").checkPropTypes(propTypes, props, 'prop', displayName);
    }
  }
}

function beforeRender(props) {
  _assign__("currentComponent", this);
}

function afterRender() {
  if (_get__("currentComponent") === this) {
    _assign__("currentComponent", null);
  }
}

function Component$1(props, context, opts) {
  _get__("Component").call(this, props, context);

  this.state = this.getInitialState ? this.getInitialState() : {};
  this.refs = {};
  this._refProxies = {};

  if (opts !== _get__("BYPASS_HOOK")) {
    _get__("newComponentHook").call(this, props, context);
  }
}

_get__("extend")(_get__("Component$1").prototype = new (_get__("Component"))(), {
  constructor: _get__("Component$1"),
  isReactComponent: {},
  replaceState: function replaceState(state, callback) {
    var this$1 = this;
    this.setState(state, callback);

    for (var i in this$1.state) {
      if (!(i in state)) {
        delete this$1.state[i];
      }
    }
  },
  getDOMNode: function getDOMNode() {
    return this.base;
  },
  isMounted: function isMounted() {
    return !!this.base;
  }
});

function PureComponent(props, context) {
  _get__("Component$1").call(this, props, context);
}

_get__("F").prototype = _get__("Component$1").prototype;
_get__("PureComponent").prototype = new (_get__("F"))();
_get__("PureComponent").prototype.isPureReactComponent = true;

_get__("PureComponent").prototype.shouldComponentUpdate = function (props, state) {
  return _get__("shallowDiffers")(this.props, props) || _get__("shallowDiffers")(this.state, state);
};

function unstable_batchedUpdates(callback) {
  callback();
}

var index = {
  version: _get__("version"),
  DOM: _get__("DOM"),
  PropTypes: _get__("PropTypes"),
  Children: _get__("Children"),
  render: _get__("render$1"),
  hydrate: _get__("render$1"),
  createClass: _get__("createClass"),
  createContext: _get__("createContext"),
  createPortal: _get__("createPortal"),
  createFactory: _get__("createFactory"),
  createElement: _get__("createElement"),
  cloneElement: _get__("cloneElement$1"),
  createRef: _get__("createRef"),
  isValidElement: _get__("isValidElement"),
  findDOMNode: _get__("findDOMNode"),
  unmountComponentAtNode: _get__("unmountComponentAtNode"),
  Component: _get__("Component$1"),
  PureComponent: _get__("PureComponent"),
  unstable_renderSubtreeIntoContainer: _get__("renderSubtreeIntoContainer"),
  unstable_batchedUpdates: _get__("unstable_batchedUpdates"),
  __spread: _get__("extend")
};
export default _get__("index");
export { version, DOM, Children, render$1 as render, render$1 as hydrate, createClass, createPortal, createFactory, createElement, cloneElement$1 as cloneElement, isValidElement, findDOMNode, unmountComponentAtNode, Component$1 as Component, PureComponent, renderSubtreeIntoContainer as unstable_renderSubtreeIntoContainer, unstable_batchedUpdates, extend as __spread };

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function registerResetAll() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable['__rewire_reset_all__']) {
    theGlobalVariable['__rewire_reset_all__'] = function () {
      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
    };
  }
})();

var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case "DEV":
      return DEV;

    case "h":
      return h;

    case "VNode":
      return VNode;

    case "REACT_ELEMENT_TYPE":
      return REACT_ELEMENT_TYPE;

    case "options":
      return options;

    case "oldEventHook":
      return oldEventHook;

    case "extend":
      return extend;

    case "normalizeVNode":
      return normalizeVNode;

    case "handleComponentVNode":
      return handleComponentVNode;

    case "handleElementVNode":
      return handleElementVNode;

    case "oldVnodeHook":
      return oldVnodeHook;

    case "CAMEL_PROPS":
      return CAMEL_PROPS;

    case "render":
      return render;

    case "ContextProvider":
      return ContextProvider;

    case "render$1":
      return render$1;

    case "renderSubtreeIntoContainer":
      return renderSubtreeIntoContainer;

    case "Portal":
      return Portal;

    case "EmptyComponent":
      return EmptyComponent;

    case "Children":
      return Children;

    case "ARR":
      return ARR;

    case "createElement":
      return createElement;

    case "ELEMENTS":
      return ELEMENTS;

    case "i":
      return i;

    case "DOM":
      return DOM;

    case "createFactory":
      return createFactory;

    case "upgradeToVNodes":
      return upgradeToVNodes;

    case "isValidElement":
      return isValidElement;

    case "createClass":
      return createClass;

    case "wrapStatelessComponent":
      return wrapStatelessComponent;

    case "COMPONENT_WRAPPER_KEY":
      return COMPONENT_WRAPPER_KEY;

    case "applyClassName":
      return applyClassName;

    case "isStatelessComponent":
      return isStatelessComponent;

    case "statelessComponentHook":
      return statelessComponentHook;

    case "currentComponent":
      return currentComponent;

    case "createStringRefProxy":
      return createStringRefProxy;

    case "applyEventNormalization":
      return applyEventNormalization;

    case "cloneElement":
      return cloneElement;

    case "multihook":
      return multihook;

    case "classNameDescriptor":
      return classNameDescriptor;

    case "bindAll":
      return bindAll;

    case "Component$1":
      return Component$1;

    case "BYPASS_HOOK":
      return BYPASS_HOOK;

    case "newComponentHook":
      return newComponentHook;

    case "applyMixins":
      return applyMixins;

    case "collateMixins":
      return collateMixins;

    case "F":
      return F;

    case "AUTOBIND_BLACKLIST":
      return AUTOBIND_BLACKLIST;

    case "callMethod":
      return callMethod;

    case "propsHook":
      return propsHook;

    case "beforeRender":
      return beforeRender;

    case "afterRender":
      return afterRender;

    case "PropTypes":
      return PropTypes;

    case "Component":
      return Component;

    case "PureComponent":
      return PureComponent;

    case "shallowDiffers":
      return shallowDiffers;

    case "version":
      return version;

    case "createContext":
      return createContext;

    case "createPortal":
      return createPortal;

    case "cloneElement$1":
      return cloneElement$1;

    case "createRef":
      return createRef;

    case "findDOMNode":
      return findDOMNode;

    case "unmountComponentAtNode":
      return unmountComponentAtNode;

    case "unstable_batchedUpdates":
      return unstable_batchedUpdates;

    case "index":
      return index;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {
    case "DEV":
      return DEV = _value;

    case "i":
      return i = _value;

    case "currentComponent":
      return currentComponent = _value;
  }

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (_typeof(variableName) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)["catch"](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = _typeof(index);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(index, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(index)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

export { _get__ as __get__, _get__ as __GetDependency__, _set__ as __Rewire__, _set__ as __set__, _reset__ as __ResetDependency__, _RewireAPI__ as __RewireAPI__ };